import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { AppSettingService } from '../services/app-setting.service';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  login(model): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'x-www-from-urlencoded' });

    model.Password = encodeURIComponent(model.Password);
    var body = JSON.stringify(model);
    var data = 'Grant_Type=password&UserName=' + model.UserName + '&Password=' + model.Password + '&RememberMe=' + model.RememberMe;
    return this.http
      .post(AppSettingService.loginUri, data, {
        headers: headers
      }).pipe(catchError(this.error));

  }
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }
  isUniqueEmailAddress(email: string): Observable<any> {

    return this.http
      .post(AppSettingService.validateEmailAddressUri, email)
      .pipe(catchError(this.error));
  }

  register(model) {

    return this.http.post(AppSettingService.registerUri, model).pipe(catchError(this.error))

  }
  isTaxIdExist(taxId: string): Observable<any> {

    return this.http
      .post(AppSettingService.validateTaxIdUri, taxId)
      .pipe(catchError(this.error));
  }

  sendPassword(emailaddress: any): Observable<any> {



    return this.http
      .post(AppSettingService.forgotPasswordUri, emailaddress)
      .pipe(catchError(this.error));
  }

  activateUser(token: any): Observable<any> {


    return this.http
      .get(AppSettingService.activateUserUri + "?token=" + (token))
      .pipe(catchError(this.error));
  }

  
  loginAsMember(accessToken):Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'bearer '+accessToken});
   
 
  return  this.http
   .post(AppSettingService.loginAsMemberUri, "", {
     headers: headers
   }).pipe(catchError(this.error));

   }
   
   getBHSSOUrl(providerId):Observable<any> {
    let timezone =Intl.DateTimeFormat().resolvedOptions().timeZone;

    return this.http
    .get(AppSettingService.getBHSSOUrl + "?providerId=" + (providerId) +"&timezone=" + timezone)
    .pipe(catchError(this.error));

   }
   


}